import { makeStyles } from 'tss-react/mui';

// Styles
import { colors } from '../../../styles/palette';

export const useStyles = makeStyles()((theme) => ({
  accent: { color: colors.gilead.primary1, marginTop: 16 },
  message: {
    fontSize: 18,
    lineHeight: '22px',
    letterSpacing: '0.2px',
    marginTop: theme.spacing(1.5),
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
      lineHeight: '18px',
      letterSpacing: '0.1px',
      marginTop: theme.spacing(1),
    },
  },
  buttons: {
    paddingBottom: 0,
    '& #reject-button': {
      width: 81,
    },
    '& #accept-button': {
      minWidth: 50,
      width: 50,
    },
    [theme.breakpoints.down('lg')]: {
      paddingRight: 30,
      '& #reject-button': {
        width: 116,
      },
      '& #accept-button': {
        width: 100,
      },
    },
    [theme.breakpoints.down('md')]: {
      justifyContent: 'flex-start',
      columnGap: 8,
      paddingRight: 0,
      paddingLeft: 0,
      '& #reject-button': {
        height: 44,
      },
    },
  },
}));
